import { Vue, Component } from 'vue-property-decorator'
import { List } from 'vant'

interface InitResult {
  loading: boolean
  finished: boolean
  list: any[]
  error: boolean
  pageIndex: number
  pageSize: number
}

const initResult: InitResult = {
  loading: false,
  finished: false,
  list: [],
  error: false,
  pageIndex: 0, //0 未请求 1:第1页 2:第2页
  pageSize: 10
}

@Component({
  components: {
    [List.name]: List
  }
})
export class LoadList extends Vue {
  result: InitResult = {
    ...initResult
  }

  get loadingText() {
    return this.result.pageIndex <= 1 ? '' : '加载中...'
  }

  get finishedText() {
    return ''
  }
  get showEntity() {
    return this.result.list.length > 0
  }
  get showEmpty() {
    return this.result.finished && this.result.list.length === 0
  }
  setInitResult() {
    const list = this.result.list
    this.result = { ...initResult, list }
  }
}
